import { IBeneficiosVaVr } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IBeneficiosVaVrState {
    data: IBeneficiosVaVr;
    loading: boolean;
    error: string | null;
}

const initialState: IBeneficiosVaVrState = {
    data: {} as IBeneficiosVaVr,
    loading: false,
    error: null
};

export const beneficiosVaVrSlice = createSlice({
    name: 'beneficiosVaVr',
    initialState,
    reducers: {
        beneficiosVaVr_fetching: (state) => {
            state.loading = true;
            state.data = {} as IBeneficiosVaVr;
            state.error = null;
        },
        beneficiosVaVr_success: (state, action: PayloadAction<IBeneficiosVaVr>) => {
            state.error = null;
            state.loading = false;
            state.data = action.payload;
        },
        beneficiosVaVr_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = {} as IBeneficiosVaVr;
        }
    }
});

export const { beneficiosVaVr_fetching, beneficiosVaVr_success, beneficiosVaVr_error } = beneficiosVaVrSlice.actions;

export const selectorBeneficiosVaVr = (state: AppState) => state.beneficiosVaVr;

export default beneficiosVaVrSlice.reducer;
